// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__h0QKu","modalForm":"UpgradeEpcsModal_modalForm__PdTRy","modalFooter":"UpgradeEpcsModal_modalFooter__ewehD"};